/**
 * Canonical role value -> display-label map.
 *
 * DERIVED, NOT DECLARED. This file used to hold its own 15-entry VALID_ROLES
 * array, which is how `patient_experience` came to be a fully-defined role
 * (60 permissions, migration 097, legal in users_role_check) that no admin could
 * assign. The single definition now lives in src/lib/roleCatalog.js and every
 * consumer derives from it; tests/unit/security/roleCatalogConformance.test.js
 * asserts both directions, so a role added to ROLE_PERMISSIONS without becoming
 * reachable is now a CI failure rather than a silent gap.
 *
 * The old header said "When adding a role, update this list AND a migration" —
 * that instruction is what drifted. Add the role to the catalog instead.
 */
const {
  assignableRoles, ROLE_CATALOG,
} = require('../lib/roleCatalog');

/** Assignable roles, in catalog order — the user-management dropdown. */
const VALID_ROLES = assignableRoles();

/**
 * Label lookup over the WHOLE catalog, not just the assignable subset: a user
 * whose stored role is not currently assignable (e.g. a legacy value) still
 * renders with its proper label instead of a snake_case fallback.
 */
const ROLE_LABEL = Object.fromEntries(ROLE_CATALOG.map((r) => [r.key, r.label]));

// Canonical label for a role. Falls back to a snake_case -> spaced transform
// for any unknown role so a new/unmapped value still renders readably
// (never a partial "BOARD OF_DIRECTORS").
function roleLabel(role) {
  if (!role) return '';
  return ROLE_LABEL[role] || role.replace(/_/g, ' ');
}

module.exports = { VALID_ROLES, ROLE_LABEL, roleLabel };
